import type { StructureEditor } from '@deity-io/di-data-structure-editor';

const editorCache: { hash: string; editor: StructureEditor | undefined } = { hash: '', editor: undefined };

export const buildPath = (path?: string[]) => `/${path?.join('/')}`;

export const getConnectionOptions = (editor: StructureEditor, path: string[], isSource: boolean) => {
  const pathStr = buildPath(path);
  const options = {
    canDanglingConnect: [false, []] as ReturnType<typeof editor.canCreateSourceMapping>,
    canDisconnect: [false, []] as ReturnType<typeof editor.disconnectSource>,
    canRemove: [false, []] as ReturnType<typeof editor.removeBySource>
  };

  if (isSource) {
    options.canDanglingConnect = editor.canCreateSourceMapping(pathStr);
    options.canDisconnect = editor.disconnectSource(pathStr, true);
    options.canRemove = editor.removeBySource(pathStr, true);
  } else {
    options.canDanglingConnect = editor.canCreateTargetMapping(pathStr);
    options.canDisconnect = editor.disconnectTarget(pathStr, true);
    options.canRemove = editor.removeByTarget(pathStr, true);
  }

  return options;
};

export const flattenModelTree = (v: {}, parentField: any, path: string[]) => {
  Object.keys(parentField)
    .filter(k => k !== '_meta')
    .forEach(k => {
      const isContainerField = parentField[k]?._meta;
      const fieldPath: string[] = [...path, k];
      v[fieldPath.join('.')] = {
        path: fieldPath,
        properties: isContainerField ? parentField[k]._meta : parentField[k]
      };
      if (isContainerField) {
        flattenModelTree(v, parentField[k], fieldPath);
      }
    });
};
